module.exports = __webpack_public_path__ + "img/FR30788.3c47a2d0.png";